module.exports = __webpack_public_path__ + "media/music5.634e1845.mp3";